import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import {
  masifiWaGroupIncomingLayout,
  masifiWaTeamContactId,
  masifiWaTeamEchoLayout,
} from 'dashboard/helper/masifi/masifiWaGroups';

// Masifi: WhatsApp QR (F3a). Avatar de los mensajes de GRUPO en el slot nativo de Message.vue (1 computed + guardas):
// - entrante (E2E fix 4): columna de avatar a la izquierda + foto del participante (masifiWaGroupIncomingLayout);
// - eco de un compañero "Es de mi equipo" (E2E fix 5): la grilla nativa de la derecha, con la foto del contacto del
//   compañero en vez del ícono del inbox, y el tooltip "Enviado por <nombre>" (el nativo del eco habla de la app nativa).
// La foto sale del store NATIVO de contactos (se actualiza en vivo con contact.updated); si el contacto no está cargado,
// se pide UNA vez con el contacts/show nativo (pocos compañeros por grupo; nunca una request por burbuja).
// null = layout nativo.
const requestedContacts = new Set();

export const useMasifiWaGroupLayout = props => {
  const store = useStore();
  const { t } = useI18n();
  const teamContactId = computed(() => masifiWaTeamContactId(props));
  const contactOf = id => store.getters['contacts/getContact'](id);

  watch(
    teamContactId,
    id => {
      if (!id || requestedContacts.has(id) || contactOf(id)?.id) return;
      requestedContacts.add(id);
      store.dispatch('contacts/show', { id });
    },
    { immediate: true }
  );

  return computed(() => {
    const incoming = masifiWaGroupIncomingLayout(props);
    if (incoming) return incoming;
    const contact = teamContactId.value ? contactOf(teamContactId.value) : null;
    const team = masifiWaTeamEchoLayout(props, contact);
    if (!team) return null;
    return {
      ...team,
      tooltip: `${t('CONVERSATION.SENT_BY')} ${team.avatar.name}`,
    };
  });
};
